import { useAuth0 } from "@developertown/oidc-provider";
import { getDevUserEmail, isAuthBypassed } from "../env";

const devUser = {
  email: getDevUserEmail(),
  name: "Dev User",
  sub: "dev|local",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const devLogout = (_opts?: any) => {
  sessionStorage.clear();
  window.location.href = "/";
};

const devAuth = {
  isAuthenticated: true,
  isLoading: false,
  error: undefined,
  user: devUser,
  loginWithRedirect: () => Promise.resolve(),
  getAccessTokenSilently: () => Promise.resolve("dev-token"),
  logout: devLogout,
};

const authBypassed = isAuthBypassed();

/**
 * Drop-in replacement for useAuth0().
 * When VITE_AUTH_BYPASS is "true", returns a static dev identity
 * so the app can run without an Auth0 tenant.
 *
 * The bypass decision is resolved once at module load so the hook path
 * remains stable for the lifetime of the runtime.
 */
export const useAuth = () => {
  if (authBypassed) {
    return devAuth;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useAuth0();
};
